import axios from 'axios'
import { storeSurveyAccessToken } from '~/utils/surveyAnswerSetAccess'

export const state = {
  Surveys: []
}
export const getters = {
  surveys: (state) => {
    return state.Surveys.sort((a, b) => {
      return a.order - b.order
    })
  },
  surveyById: (state) => (surveyId) => {
    return state.Surveys.find(survey => survey.id === surveyId)
  },
  surveysByIds: (state) => (surveyIds) => {
    return state.Surveys.filter(survey => surveyIds.indexOf(survey.id) > -1)
  }
}

export const mutations = {
  surveys (state, surveys) {
    state.Surveys = surveys
  },
  surveyPatch (state, survey) {
    const index = state.Surveys.findIndex(item => item.id === survey.id)
    if (index > -1) {
      state.Surveys.splice(index, 1, survey)
    } else {
      state.Surveys.push(survey)
    }
  },
  surveyDelete (state, surveyId) {
    const index = state.Surveys.findIndex(item => item.id === surveyId)
    if (index > -1) {
      state.Surveys.splice(index, 1)
    }
  }
}

export const actions = {
  async surveyById (store, surveyId) {
    const { data } = await axios.get('/api/surveys/' + surveyId)
    store.commit('surveyPatch', data)
    return data
  },
  async surveys (store, params = {}) {
    if (!params.page) {
      params.page = 1
    }
    const { data } = await axios.get('/api/surveys', { params: params })

    store.commit('surveys', data.data)
    return data
  },
  async surveyDelete (store, surveyId) {
    await axios.delete('/api/surveys/' + surveyId)
    store.commit('surveyDelete', surveyId)
  },
  async surveyPatch (store, payload = {}) {
    const { data } = await axios.patch('/api/surveys/' + payload.id, payload)
    store.commit('surveyPatch', data)
    return data
  },
  async surveyStart (store, payload = {}) {
    const { data } = await axios.post('/api/survey-answer-sets', payload)
    if (data.access_token) {
      storeSurveyAccessToken(data.id, data.access_token)
      delete data.access_token
    }
    store.commit('surveyAnswerSets/surveyAnswerSetPatch', data, { root: true })
    return data
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
